import { DetailedRoute } from '@/generated/model/detailedRoute';

export function sumDistance(routes: DetailedRoute[]) {
  if (!routes) return formatDistanceKm(0);
  const distanceSumKm: number = routes.reduce((acc, current) => acc + current.distanceKm, 0.0);
  return formatDistanceKm(distanceSumKm);
}

export function formatDistanceKm(distanceKm: number) {
  if (isNaN(distanceKm)) return '0 m';
  if (distanceKm < 1.0) {
    const distanceMeter = (distanceKm * 1000).toFixed(0);
    return `${distanceMeter} m`;
  }
  return `${distanceKm.toFixed(1)} km`;
}
